import {afterNextRender, Component, inject, Input, signal, Signal, ViewChild} from '@angular/core';
import {MatSidenav, MatSidenavContainer, MatSidenavModule} from '@angular/material/sidenav';
import {MatButton, MatFabButton, MatMiniFabButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {CurrentObjectContext} from '../current-object.context';
import {ResizableDirective} from '../../resizable.directive';

@Component({
    selector: 'app-object-page-layout',
    imports: [
        MatSidenavModule,
        MatFabButton,
        MatButton,
        MatIcon,
        TranslateModule,
        ResizableDirective,
        MatMiniFabButton,
    ],
    templateUrl: './object-page-layout.component.html',
    styleUrl: './object-page-layout.component.scss'
})
export class ObjectPageLayoutComponent {
  // Injections
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  private readonly currentObjectContext: CurrentObjectContext = inject(CurrentObjectContext);

  @Input() disableNavigation: boolean = false;
  @Input() disableRightDrawer: boolean = false;
  @Input() defaultImageDrawerWidth?: string;

  @ViewChild('rightDrawer') rightDrawer: MatSidenav;
  @ViewChild('navigationDrawer') navigationDrawer: MatSidenav;
  @ViewChild('matSidenavContainer') matSidenavContainer: MatSidenavContainer;

  isSmallScreen: Signal<boolean>
  rightDrawerOpened = signal(false);

  constructor() {
    this.isSmallScreen = toSignal(this.breakpointObserver.observe('(max-width: 1024px)').pipe(map(result => result.matches)));

    afterNextRender(() => {
      this.rightDrawerOpened.set(this.rightDrawer?.opened ?? false);
      this.matSidenavContainer?.updateContentMargins();
    });
  }

  get isEditing() {
    return this.currentObjectContext.isEditing;
  }

  toggleRightDrawer() {
    this.rightDrawer?.toggle();
    this.rightDrawerOpened.set(this.rightDrawer?.opened ?? false);
  }

  toggleNavigationDrawer() {
    this.navigationDrawer?.toggle(undefined, 'program')
  }

  setRightDrawerWidth(width: string) {
    // @ts-ignore
    this.rightDrawer?._elementRef?.nativeElement?.style.setProperty('width', width);
    this.matSidenavContainer?.updateContentMargins();
  }
}
